import React, {useEffect, useState} from 'react';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {CampaignService} from "../../service/CampaignService";
import {Button} from "primereact/button";
import WebSearchSetting from "./WebSearchSetting";
import {Panel} from "primereact/panel";
import JobSchedulingTimeSetting from "./JobSchedulingTimeSetting";
import {AppContext} from "../../HomePage";
import {Loading, IndexTemplate} from "../../utils/InlineComponents";
import {InputSwitch} from "primereact/inputswitch";

const InstantWebSearchSetting = (props) => {

    const {t, setError} = React.useContext(AppContext);

    const [campaign, setCampaign] = useState(props.campaign);
    const [loading, setLoading] = useState(false);

    const [searchCompetitors, setSearchCompetitors] =
        useState(campaign.settings && campaign.settings.competitor_suggestion && campaign.settings.competitor_suggestion.competitor_urls ? [...campaign.settings.competitor_suggestion.competitor_urls.map(c => ({url: c}))] : []);

    const [excludedSearchCompetitors, setExcludedSearchCompetitors] =
        useState(campaign.settings && campaign.settings.competitor_suggestion && campaign.settings.competitor_suggestion.excluded_competitor_urls ? [...campaign.settings.competitor_suggestion.excluded_competitor_urls.map(c => ({url: c}))] : []);

    const [campaignCompetitors, setCampaignCompetitors] = useState(null)
    const campaignService = new CampaignService();

    let competitor_suggestion = campaign.settings && campaign.settings.competitor_suggestion ? campaign.settings.competitor_suggestion : {}

    useEffect ( ()=>{
        campaign.settings.competitor_suggestion = competitor_suggestion

        if (campaign.id) {
            setLoading(true);
            campaignService.getCampaignCompetitors(campaign.id).then((competitors) => {
                setCampaignCompetitors(competitors);
                setLoading(false);
            }).catch(error =>{
                setError(error);
                setError(null);
                setLoading(false);
            });
        }

    },[]);

    const isURLExcluded = (rowData) => {
        return excludedSearchCompetitors.some(item => item.url === rowData.url)
    }

    const excludeURL = (rowData) => {
        if (isURLExcluded(rowData)) {
            let filteredURLs = excludedSearchCompetitors.filter(item => item.url !== rowData.url)
            setExcludedSearchCompetitors(filteredURLs)
            competitor_suggestion.excluded_competitor_urls = filteredURLs.map(s => s.url)
        } else {
            excludedSearchCompetitors.push({url: rowData.url})
            setExcludedSearchCompetitors([...excludedSearchCompetitors])
            competitor_suggestion.excluded_competitor_urls = excludedSearchCompetitors.map(s => s.url)
        }
    }

    const urlTemplate = (rowData) => <a target="_blank" rel="noopener noreferrer" href={rowData.url}>{rowData.url}</a>;

    const actionTemplate = (rowData) => {
        return <React.Fragment>
            <InputSwitch checked={isURLExcluded(rowData)} onChange={() => excludeURL(rowData)}
                         tooltipOptions={{position: 'bottom'}} style={{marginRight:"0.5em"}}
                         tooltip={isURLExcluded(rowData) ? t('actions.suggest_from_host') : t('actions.not_suggest_from_host') } />
            {rowData.is_site_searching_ready && <Button type="button" icon="pi pi-check" className="p-button-rounded p-button-success p-button-text"/>}
            {!rowData.is_site_searching_ready && <Button type="button" icon="pi pi-minus" className="p-button-rounded p-button-danger p-button-text"/>}
        </React.Fragment>;
    };

    return (
        <div className="p-grid p-fluid">
            <Panel header={t('campaign.generic_setting')} style={{height:'100%'}}>
                <WebSearchSetting webSearchSetting={competitor_suggestion}/>
            </Panel>

            <p></p>

            {loading ?
                <div className="p-col-12" style={{textAlign: 'center'}}>
                    <Loading/>
                </div> :
                <Panel header={t('suggestion.competitor_settings')} style={{height:'100%'}}>
                        <div className="p-col-12 p-xl-12">
                            <DataTable value={campaignCompetitors} dataKey="url" responsive={true}
                                       sortField="url" sortOrder={1}
                                       selection={searchCompetitors}
                                       onSelectionChange={e => {
                                           competitor_suggestion.competitor_urls = e.value.map(s => s.url);
                                           setSearchCompetitors(e.value)
                                       }}>
                                <Column selectionMode="multiple" style={{width: '3em'}}/>
                                <Column header={t('table_headers.index')} style={{width: '5em'}} body={IndexTemplate}/>
                                <Column field="url" body={urlTemplate} header={t('campaign.competitors.url')} sortable
                                       />
                                <Column body={actionTemplate} header={t('actions.search_competitors_on_website')}
                                        style={{textAlign: 'center', width: '10em'}}/>
                            </DataTable>
                        </div>
                </Panel>
            }
        </div>
    );

};
export default (InstantWebSearchSetting)
